export default __webpack_public_path__ + "static/950-c495cf04568536ff57ef46dbfa3825e8.gif";